import { usePropertyStructureType } from '../../../queries/PropertyFields/TopLevelFields';
import { usePropertyPreSold } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { usePropertySpecSheetFile } from '../../../queries/PropertyFileFields/NonRentalFiles';

import { ShowIf } from '../../components/ShowIf';
import { StructureType } from '../components/StructureType';
import { Units } from '../components/Units';
import { PropertyAddress } from '../components/PropertyAddress/PropertyAddress';
import { LegalDescription } from '../components/LegalDescription';
import { LandSize } from '../components/LandSize';
import { BudgetFile } from '../../components/FileOrFormQuestions/questions/BudgetFile';
import { PlansFile } from '../../components/FileOrFormQuestions/questions/PlansFile';
import { SpecSheetFile } from '../../components/FileOrFormQuestions/questions/SpecSheetFile';
import { SurveyFile } from '../../components/FileOrFormQuestions/questions/SurveyFile';
import { PreSold } from '../components/PreSold';
import { PreSaleContractFile } from '../../components/FileOrFormQuestions/questions/PreSaleContractFile';
import { ExpectedListingPrice } from '../components/ExpectedListingPrice';
import { ConstructionStarted } from '../components/ConstructionStarted';
import { ProvideLaterAdvisory } from '../components/ProvideLaterAdvisory';

export interface ConstructionLocProps {
    disableEditFormOptionBudget: boolean;
    disableEditFormOptionSpecSheet: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const ConstructionLoc: React.FC<ConstructionLocProps> = ({
    disableEditFormOptionBudget,
    disableEditFormOptionSpecSheet,
    propertyGuid,
    isReview = false,
}) => {
    const [structureType] = usePropertyStructureType(propertyGuid);
    const [preSold] = usePropertyPreSold(propertyGuid);
    const { handleMode: specSheetHandle } = usePropertySpecSheetFile(propertyGuid);

    return (
        <>
            <StructureType
                propertyGuid={propertyGuid}
                isReview={isReview}
            />
            <ShowIf showIf={structureType === '5+ Unit'}>
                <Units
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                />
            </ShowIf>
            <PropertyAddress
                propertyGuid={propertyGuid}
                required={true}
                isReview={isReview}
            />
            <ShowIf showIf={!isReview}>
                <br />
                <br />
                <div className='pageSubHeader'>Additional Information</div>
            </ShowIf>
            <LegalDescription
                propertyGuid={propertyGuid}
                isReview={isReview}
            />
            <LandSize
                propertyGuid={propertyGuid}
                isReview={isReview}
            />
            <ShowIf showIf={!isReview}>
                <br />
                <br />
                <div className='pageSubHeader'>Additional Files</div>
            </ShowIf>
            <BudgetFile
                propertyGuid={propertyGuid}
                disableEditFormOptionBudget={disableEditFormOptionBudget}
                required={true}
                isReview={isReview}
            />
            <PlansFile
                propertyGuid={propertyGuid}
                required={true}
                isReview={isReview}
            />
            <SpecSheetFile
                propertyGuid={propertyGuid}
                disableEditFormOptionSpecSheet={disableEditFormOptionSpecSheet}
                required={true}
                isReview={isReview}
            />
            <ShowIf showIf={!isReview && specSheetHandle === 'willnotprovide'}>
                <p style={{ color: 'red', marginLeft: 20 }}>
                    NOTE: Without this detail, the appraiser is likely to assume the lowest grade materials.
                </p>
            </ShowIf>
            <SurveyFile
                propertyGuid={propertyGuid}
                required={true}
                isReview={isReview}
            />
            <PreSold
                propertyGuid={propertyGuid}
                required={true}
                isReview={isReview}
            />
            <ShowIf showIf={preSold}>
                <PreSaleContractFile
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                />
            </ShowIf>
            <ShowIf showIf={preSold === false}>
                <ExpectedListingPrice
                    structureType={structureType}
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                />
            </ShowIf>
            <ProvideLaterAdvisory
                propertyGuid={propertyGuid}
                isReview={isReview}
            />
            <ConstructionStarted
                propertyGuid={propertyGuid}
                required={true}
                isReview={isReview}
            />
        </>
    );
};
